import styles from './index.module.scss';
import { Card, Typography } from '@navi/web-ui/lib/primitives';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { DateFormat, formatDate } from '@cp/src/utils/DateHelper';
import { useEffect } from 'react';
import { getReUploadSummary, reUploadInitiate } from './action';
import AllocationStatusDisplay from './AllocationStatusDisplay';

const SuccessAllocationDetails = () => {
  const dispatch = useDispatch();

  const reUploadSummaryData = useSelector(
    (state: RootState) => state.allocations?.reUploadSummaryData
  );
  const completionStatus = reUploadSummaryData?.runMetrics?.completionStatus;

  useEffect(() => {
    dispatch(getReUploadSummary());
  }, []);

  const handleReupload = () => {
    dispatch(
      reUploadInitiate(() => {
        dispatch(getReUploadSummary());
      })
    );
  };

  return (
    <Card className={styles.midContainer}>
      <div className="flex items-center justify-between gap-4 px-5 py-4">
        <div className="flex items-center gap-2 flex-1">
          <Typography variant="h4" color="var(--navi-color-gray-c2)">
            Ameyo last updated:
          </Typography>
          <Typography variant="h4" color="var(--navi-color-gray-c1)">
            {formatDate(
              reUploadSummaryData?.updatedAt as string,
              DateFormat.DD_MMM_YYYY__hh_mm_a
            ) || '-'}
          </Typography>
        </div>

        <AllocationStatusDisplay completionStatus={completionStatus} onReupload={handleReupload} />
      </div>
    </Card>
  );
};

export default SuccessAllocationDetails;
